/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */

export const MOTD_LOCAL_STORAGE_KEY: string = 'motd.lastModified'
export const IGNORE_MOTD: string = 'IGNORE_MOTD'
